import styled from "styled-components";

const ButtonPrimary = styled.button`
  min-height: 40px;
  font-size: 16px;
  padding: 0 30px 0 20px;
  border: solid 1px #0084ff;
  background-color: #0084ff;
  color: #fff;
  border-radius: 3px;

  cursor: pointer;
  &:hover {
    border-color: #0084ff;
    background-color: #68b6ff;
  }
`;
export default ButtonPrimary;
